import { memo } from "react";
import clsx from "clsx";
import { Modal as MuiModal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material";
import NormalText from "../Typography/NormalText";

const MuiModalStyled = styled(MuiModal)(({ theme }) => ({
  "& .wrapper": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "16px",
    backgroundColor: theme.backgroundColor.white2,
    display: "flex",
    flexDirection: "column",
    // height: "100%",
    // width: "700px",
    overflow: "hidden",
  },
  "& .title-row": {
    padding: "10px 20px 8px 20px",
  },
  "& .title": {
    float: "left",
  },
  "& .title-text": {
    color: "#424242",
    fontSize: "16px",
    flexGrow: "1",
  },
  "& .title-icon": {
    float: "right",
    cursor: "pointer",
  },
  "& .body": {
    flexGrow: "1",
    overflow: "hidden",
  },
}));

const ModalTitleMemo = memo(({ title, className }) =>
  typeof title === "string" ? (
    <NormalText className={clsx("title-text", className)}>
      {title || ""}
    </NormalText>
  ) : (
    title
  )
);

const ModalUnstyled = ({
  isOpen,
  onClose,
  title,
  children,
  className,
  classNames = {},
}) => (
  <MuiModalStyled open={isOpen} onClose={onClose} className={className}>
    <div className={clsx("wrapper", classNames.wrapper)}>
      <div className="title-row">
        <span className="title">
          <ModalTitleMemo title={title} className={classNames.title} />
        </span>
        <CloseIcon
          className={clsx("title-icon", classNames.titleIcon)}
          onClick={onClose}
        />
      </div>
      <div className={clsx("body", classNames.body)}>{children}</div>
    </div>
  </MuiModalStyled>
);
const Modal = styled(ModalUnstyled)({});
export default Modal;
